import React from 'react';
import { Modal, Descriptions, Card, Tag, Empty } from 'antd';
import { BankOutlined, HomeOutlined, PhoneOutlined, UserOutlined } from '@ant-design/icons';

function FurnizorDetails({ visible, furnizor, onClose }) {
  if (!furnizor) return null;

  return (
    <Modal
      title={`Detalii Furnizor: ${furnizor.denumire}`}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1000}
    >
      <div className="space-y-6">
        <Card title="Informații generale" size="small">
          <Descriptions column={2} size="small">
            <Descriptions.Item label="Denumire">{furnizor.denumire}</Descriptions.Item>
            <Descriptions.Item label="CF">{furnizor.id_no || '-'}</Descriptions.Item>
            <Descriptions.Item label="Cod TVA">{furnizor.cod_tva || '-'}</Descriptions.Item>
            <Descriptions.Item label="Website">
              {furnizor.website ? (
                <a href={furnizor.website} target="_blank" rel="noopener noreferrer">
                  {furnizor.website}
                </a>
              ) : '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Adresa juridică" span={2}>
              {furnizor.adresa_juridica || '-'}
            </Descriptions.Item>
          </Descriptions>
        </Card>

        {furnizor.rechizite_bancare && furnizor.rechizite_bancare.length > 0 && (
          <Card title={<><BankOutlined /> Rechizite bancare</>} size="small">
            {furnizor.rechizite_bancare.map((cont, index) => (
              <div key={index} className="mb-4 p-3 bg-gray-50 rounded">
                <Descriptions column={3} size="small">
                  <Descriptions.Item label="IBAN">{cont.iban || '-'}</Descriptions.Item>
                  <Descriptions.Item label="BIC/SWIFT">{cont.bic || '-'}</Descriptions.Item>
                  <Descriptions.Item label="Banca">{cont.banca || '-'}</Descriptions.Item>
                </Descriptions>
              </div>
            ))}
          </Card>
        )}

        {furnizor.adresa_fizica && furnizor.adresa_fizica.length > 0 && (
          <Card title={<><HomeOutlined /> Adrese fizice</>} size="small">
            {furnizor.adresa_fizica.map((adresa, index) => (
              <div key={index} className="mb-4 p-3 bg-gray-50 rounded">
                <Descriptions column={2} size="small">
                  <Descriptions.Item label="Tip">
                    <Tag color="blue">{adresa.tip || 'Nedefinit'}</Tag>
                  </Descriptions.Item>
                  <Descriptions.Item label="Oraș">{adresa.oras || '-'}</Descriptions.Item>
                  <Descriptions.Item label="Adresa" span={2}>{adresa.adresa || '-'}</Descriptions.Item>
                  {adresa.comentariu && (
                    <Descriptions.Item label="Comentariu" span={2}>{adresa.comentariu}</Descriptions.Item>
                  )}
                </Descriptions>
              </div>
            ))}
          </Card>
        )}

        {furnizor.contact && furnizor.contact.length > 0 && (
          <Card title={<><PhoneOutlined /> Persoane de contact</>} size="small">
            {furnizor.contact.map((contact, index) => (
              <div key={index} className="mb-4 p-3 bg-gray-50 rounded">
                <Descriptions column={2} size="small">
                  <Descriptions.Item label="Nume">
                    <span className="font-medium">{contact.nume_prenume || '-'}</span>
                    {contact.principal_dahnu && <Tag color="gold" className="ml-2">Principal</Tag>}
                  </Descriptions.Item>
                  <Descriptions.Item label="Poziție">{contact.pozitie || '-'}</Descriptions.Item>
                  <Descriptions.Item label="Telefon">{contact.telefon || '-'}</Descriptions.Item>
                  <Descriptions.Item label="Email">{contact.email || '-'}</Descriptions.Item>
                </Descriptions>
              </div>
            ))}
          </Card>
        )}

        <Card title="Termeni comerciali" size="small">
          <Descriptions column={3} size="small">
            <Descriptions.Item label="Termen de plată">{furnizor.termen_de_plata || '-'}</Descriptions.Item>
            <Descriptions.Item label="Termen de livrare">{furnizor.termen_de_livrare || '-'}</Descriptions.Item>
            <Descriptions.Item label="Tip de achitare">{furnizor.tip_de_achitare || '-'}</Descriptions.Item>
          </Descriptions>
        </Card>

        {furnizor.manager_atasat && furnizor.manager_atasat.length > 0 && (
          <Card title={<><UserOutlined /> Manageri atașați</>} size="small">
            {furnizor.manager_atasat.map((manager, index) => (
              <div key={index} className="mb-2 p-3 bg-gray-50 rounded">
                <Descriptions column={3} size="small">
                  <Descriptions.Item label="Nume">{manager.nume_prenume || '-'}</Descriptions.Item>
                  <Descriptions.Item label="Poziție">{manager.pozitie || '-'}</Descriptions.Item>
                  <Descriptions.Item label="Telefon">{manager.telefon || '-'}</Descriptions.Item>
                </Descriptions>
              </div>
            ))}
          </Card>
        )}
      </div>
    </Modal>
  );
}

export default FurnizorDetails; 